module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<article class="job-description">\n    <div class="job-icon">\n        <div class="job-line"></div>\n        <div class="job-icon-container';
 if (!data.complete_data) { ;
__p += ' tooltip alert-tooltip" data-tooltip="Required fields missing"';
 } else { ;
__p += '"';
 } ;
__p += ' >\n            ' +
((__t = ( $.svgIcon('briefcase') )) == null ? '' : __t) +
'\n        </div>\n        ';
 if (!data.complete_data) { ;
__p += '\n            <div class="job-overlay-warning-icon">\n                ' +
((__t = ( $.svgIcon('warning') )) == null ? '' : __t) +
'\n            </div>\n        ';
 } ;
__p += '\n    </div>\n    <div class="job-content">\n        <header>\n            ';
 if (data.title) { ;
__p += '\n                <div class="job-title">\n                  <strong class="item-title job-title__role">' +
__e( data.title ) +
'</strong>\n                  ';
 if (data.displayAsContractJob) { ;
__p += '\n                      <span class="job-title__contract">Contract</span>\n                  ';
 } ;
__p += '\n                </div>\n            ';
 } else { ;
__p += '\n                <strong class="item-title missing-section">Job title missing</strong>\n            ';
 } ;
__p += '\n            ';
 if (data.company) { ;
__p += '\n                <span class="company fs-hide">' +
__e( data.company ) +
'</span>\n            ';
 } else { ;
__p += '\n                <span class="company fs-hide missing-section">Company name missing</span>\n            ';
 } ;
__p += '\n            <div class="dates">\n                ';
 if (data.end_date && data.start_date) { ;
__p += '\n                    <span class="date-range">\n                        ' +
__e( data.dates ) +
'\n                        ';
 if (!data.miniCard) { ;
__p += '\n                            &bull; ' +
__e( data.durationString ) +
'\n                        ';
 } ;
__p += '\n                    </span>\n                ';
 } else { ;
__p += '\n                    <span class="date-range missing-section">Dates missing</span>\n                ';
 } ;
__p += '\n            </div>\n            ';
 if (!data.miniCard) { ;
__p += '\n                <a href="javascript://" class="edit-history">\n                    ' +
((__t = ( $.svgIcon('pencil') )) == null ? '' : __t) +
' Edit\n                </a>\n                ' +
((__t = ( $.svgIcon('pencil', 'mobile-only edit-row') )) == null ? '' : __t) +
'\n            ';
 } ;
__p += '\n        </header>\n        ';
 if (!data.miniCard) { ;
__p += '\n            ';
 if (data.duties) { ;
__p += '\n                <p class="duties">' +
__e( data.duties ) +
'</p>\n            ';
 } else { ;
__p += '\n                <p class="duties missing-section">\n                    Job duties missing\n                </p>\n            ';
 } ;
__p += '\n            ';
 if (data.reason_for_leaving) { ;
__p += '\n            <div class="reason-for-leaving fs-hide">\n                Reason for leaving: ' +
__e( data.reason_for_leaving ) +
'\n                ';
 if (data.reason_explain) { ;
__p += '\n                    (' +
__e( data.reason_explain ) +
')\n                ';
 } ;
__p += '\n            </div>\n            ';
 } ;
__p += '\n            ';
 if (data.state && data.city) { ;
__p += '\n                <span class="location fs-hide">' +
__e( data.city ) +
', ' +
__e( data.state ) +
'</span>\n            ';
 } else { ;
__p += '\n                <span class="location fs-hide missing-section">Location missing</span>\n            ';
 } ;
__p += '\n        ';
 } ;
__p += '\n    </div>\n</article>\n';

}
return __p
}